<div class="grid-bulk-scope">
  <div class="grid-bulk-scope__picker">
    <span class="grid-bulk-scope__label">{{
      "grid.bulk.scope.apply-to" | translate
    }}</span>
    <sui-button-group
      size="sm"
      [options]="options()"
      [ngModel]="mode()"
      (ngModelChange)="mode.set($event)"
    ></sui-button-group>
  </div>
  <div class="grid-bulk-scope__row">
    <span class="grid-bulk-scope__term">{{
      "grid.bulk.scope.selected" | translate
    }}</span>
    <span>{{
      "grid.bulk.scope.only-the-rows-you-ticked-in-the-grid" | translate
    }}</span>
  </div>
  <div class="grid-bulk-scope__row">
    <span class="grid-bulk-scope__term">{{
      "grid.bulk.scope.all-matching-filters" | translate
    }}</span>
    <span>{{
      "grid.bulk.scope.every-row-the-current-filters-return" | translate
    }}</span>
  </div>
</div>
